import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class ApiItalyGeoService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public getRegions(): Observable<Region[]> {
        return this.http
            .get(this.baseUrl + "/region")
            .pipe(map((data) => data as Region[]));
    }
}

export interface Region {
    id: number;
    name: string;
}
